import { SDF_BORDER_RADIUS, SDF_BOX_SHADOW, SDF_COLORS, SDF_FONTS, SDF_SPACING } from '../sdfThemeConf';
export const sdfNotificationsStyle = {
    Containers: {
        DefaultStyle: {
            width: 500,
            top: 'auto',
            bottom: 0,
            margin: '0 auto 0 -250px',
            left: '50%',
        },
    },
    NotificationItem: {
        DefaultStyle: {
            width: 500,
            minHeight: 60,
            height: 'auto',
            border: 0,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            paddingLeft: '5.5em',
            borderRadius: SDF_BORDER_RADIUS.default,
            boxShadow: SDF_BOX_SHADOW.default,
        },
        success: {
            backgroundColor: SDF_COLORS.success.main,
        },
        info: {
            backgroundColor: SDF_COLORS.primary.dark,
        },
        error: {
            backgroundColor: SDF_COLORS.error.main,
        },
        warning: {
            backgroundColor: SDF_COLORS.warning.main,
        },
    },
    Dismiss: {
        DefaultStyle: {
            display: 'none',
        },
    },
    Title: {
        DefaultStyle: {
            height: SDF_FONTS.size.mediumBig,
            fontSize: SDF_FONTS.size.mediumBig,
            fontWeight: SDF_FONTS.weight.bold,
            color: SDF_COLORS.font.light,
            marginBottom: 0,
        },
    },
    MessageWrapper: {
        DefaultStyle: {
            minHeight: 20,
            fontSize: SDF_FONTS.size.medium,
            fontWeight: SDF_FONTS.weight.normal,
            lineHeight: 1.67,
            textAlign: 'left',
            color: SDF_COLORS.font.light,
            marginTop: SDF_SPACING.margin.smallest,
        },
    },
};
//# sourceMappingURL=sdfNotificationsStyle.js.map